import { Theme, Typography } from '@mui/material'
import { isNumber } from 'lodash'
import { CSSProperties, ReactNode } from 'react'
import { FieldPath, FieldValues, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

type Props<Schema extends FieldValues> = {
  path: FieldPath<Schema>
}

export const RefreshIntervalSoftValidator = <Schema extends FieldValues>({
  path,
}: Props<Schema>): ReactNode => {
  const { t } = useTranslation('features/domain', { keyPrefix: 'form.refresher.basicSettings' })
  const value = useWatch<Schema>({ name: path })

  if (!isNumber(value)) {
    throw Error('Only number type is supported')
  }

  if (value === undefined || value >= 30) return undefined

  return (
    <Typography
      color={(theme: Theme): CSSProperties['color'] => theme.palette.warning.main}
      component='span'
      variant='caption'
    >
      {t('columns.refreshInterval.recommendedMinimum')}
    </Typography>
  )
}
